import _ from 'lodash';
import { type UnknownAction } from '@reduxjs/toolkit'

import {
  CREATE_SIMULATION_REQUEST,
  CREATING_SIMULATION_EDITOR_CHAT_FAILED,
  CREATING_SIMULATION_EDITOR_CHAT_REQUEST,
  CREATING_SIMULATION_EDITOR_CHAT_SUCCEEDED,
  CREATING_SIMULATION_FAILED,
  CREATING_SIMULATION_SUCCEEDED,
  DELETE_SIMULATION_REQUEST,
  DELETING_SIMULATION_FAILED,
  DELETING_SIMULATION_SUCCEEDED,
  DISCARD_SIMULATION_DRAFT_REQUEST,
  DISCARDING_SIMULATION_DRAFT_FAILED,
  DISCARDING_SIMULATION_DRAFT_SUCCEEDED,
  EDIT_SIMULATION_REQUEST,
  ENROLL_SIMULATION_REQUEST,
  ENROLLING_SIMULATION_FAILED,
  ENROLLING_SIMULATION_SUCCEEDED,
  FETCH_DRAFT_SIMULATION_REQUEST,
  FETCH_PUBLIC_SIMULATION_REQUEST,
  FETCHING_DRAFT_SIMULATION_FAILED,
  FETCHING_DRAFT_SIMULATION_SUCCEEDED,
  FETCHING_PERSONALITIES_FOR_SIMULATION_FAILED,
  FETCHING_PERSONALITIES_FOR_SIMULATION_REQUEST,
  FETCHING_PERSONALITIES_FOR_SIMULATION_SUCCEEDED,
  FETCHING_PUBLIC_SIMULATION_FAILED,
  FETCHING_PUBLIC_SIMULATION_SUCCEEDED,
  FETCHING_VOICES_FOR_SIMULATION_FAILED,
  FETCHING_VOICES_FOR_SIMULATION_REQUEST,
  FETCHING_VOICES_FOR_SIMULATION_SUCCEEDED,
  GENERATING_SUMMARY_FOR_SIMULATION_FAILED,
  GENERATING_SUMMARY_FOR_SIMULATION_REQUEST,
  GENERATING_SUMMARY_FOR_SIMULATION_SUCCEEDED,
  INAVLIDATE_GENERATE_SUMMARY_FOR_SIMULATION,
  INVALIDATE_SHUFFLE_OBJECTIVES_STATE,
  INVALIDATE_SHUFFLE_ORGANIZATION_STATE,
  INVALIDATE_SHUFFLE_PERSONA_STATE,
  INVALIDATE_SIMULATION_CREATION_STATE,
  INVALIDATE_SIMULATION_DELETION_STATE,
  PUBLISHING_SIMULATION_FAILED,
  PUBLISHING_SIMULATION_REQUEST,
  PUBLISHING_SIMULATION_SUCCEEDED,
  SHUFFLING_OBJECTIVES_FOR_SIMULATION_FAILED,
  SHUFFLING_OBJECTIVES_FOR_SIMULATION_REQUEST,
  SHUFFLING_OBJECTIVES_FOR_SIMULATION_SUCCEEDED,
  SHUFFLING_ORGANIZATION_FOR_SIMULATION_FAILED,
  SHUFFLING_ORGANIZATION_FOR_SIMULATION_REQUEST,
  SHUFFLING_ORGANIZATION_FOR_SIMULATION_SUCCEEDED,
  SHUFFLING_PERSONA_FOR_SIMULATION_FAILED,
  SHUFFLING_PERSONA_FOR_SIMULATION_REQUEST,
  SHUFFLING_PERSONA_FOR_SIMULATION_SUCCEEDED,
  UPDATE_SIMULATION_PROPERTY_REQUEST,
  UPDATE_VALIDATION_ERRORS_FOR_SIMULATION,
  UPDATING_SIMULATION_FAILED,
  UPDATING_SIMULATION_REQUEST,
  UPDATING_SIMULATION_SUCCEEDED,
  FETCH_LEARNER_REPORT,
  FETCHING_LEARNER_REPORT_SUCCEEDED,
  FETCHING_LEARNER_REPORT_FAILED,
  FETCH_ATTEMPTS_FOR_SIMULATION_REQUEST,
  FETCHING_ATTEMPTS_FOR_SIMULATION_SUCCEEDED,
  FETCHING_ATTEMPTS_FOR_SIMULATION_FAILED,
  FETCH_TRANSCRIPTS_FOR_SIMULATION_REQUEST,
  FETCHING_TRANSCRIPTS_FOR_SIMULATION_SUCCEEDED,
  FETCHING_TRANSCRIPTS_FOR_SIMULATION_FAILED,
  INVALIDATE_SIMULATION_UPDATE_STATE,
  CLEAR_ORGANIZATION_FOR_SIMULATION,
  CLEAR_PERSONA_FOR_SIMULATION,
  CLEAR_OBJECTIVES_FOR_SIMULATION,
  INVALIDATE_PUBLISH_SIMULATION,

} from "../../actions/actionTypes";

import {
  CreateSimulationEditorChatErrorResponse,
  CreateSimulationEditorChatRequest,
  CreateSimulationEditorChatResponse,
  CreateSimulationErrorResponse,
  CreateSimulationRequest,
  CreateSimulationResponse,
  DeleteSimulationErrorResponse,
  DeleteSimulationResponse,
  FetchPersonalitiesErrorResponse,
  FetchPersonalitiesResponse,
  FetchPublicSimulationErrorResponse,
  FetchPublicSimulationRequest,
  FetchPublicSimulationResponse,
  FetchSimulationErrorResponse,
  FetchSimulationResponse,
  FetchVoicesErrorResponse,
  FetchVoicesResponse,
  GenerateSimulationSummaryErrorResponse,
  GenerateSimulationSummaryRequest,
  GenerateSimulationSummaryResponse,
  Objectives,
  OrganizationInfo,
  Persona,
  Personality,
  PublishSimulationErrorResponse,
  PublishSimulationResponse,
  ShuffleObjectivesErrorResponse,
  ShuffleObjectivesResponse,
  ShuffleOrganizationErrorResponse,
  ShuffleOrganizationResponse,
  ShufflePersonaErrorResponse,
  ShufflePersonaResponse,
  Simulation,
  SimulationEditorSessionState,
  SimulationValidationError,
  UpdateSimulationErrorResponse,
  UpdateSimulationPropertyRequest,
  UpdateSimulationRequest,
  UpdateSimulationResponse,
  UpdateValidationErrorsForSimulationRequest,
  Voice,
  FetchLearnerReportRequest,
  FetchLearnerReportResponse,
  FetchLearnerReportErrorResponse,
  FetchAttemptsForSimulationRequest,
  FetchAttemptsForSimulationResponse,
  FetchAttemptsForSimulationErrorResponse,
} from 'src/types/coaching/simulation';
import { EnrollCourseRequest, GetSimulationTranscriptsErrorResponse, GetSimulationTranscriptsResponse } from "src/types/coaching/learners";
import { validateSimulationRequest } from 'src/pages/coaching/manage/simulations/edit/helper';
import { EnrollCourseErrorResponse, EnrollCourseResponse } from 'src/types/coaching/learners';

interface SimulationsState {
  creation: SimulationCreationState | null,
  edit: SimulationEditState | null,
  simulation: {
    [key: string]: SimulationState
  },
  update: {
    [key: string]: SimulationUpdateState;
  },
  deletion: {
    [key: string]: SimulationDeletionState;
  },
  publish: SimulationPublishState | null,
  personalities: PersonalitiesState,
  voices: VoicesState,
  learnerReport : any
  attemptLearners: {
    loading: boolean;
    loaded: boolean;
    items: any[];
    pagination: {
      currentPage: number;
      totalPages: number;
      recordsPerPage: number;
      totalRecordsCount: number;
      hasMoreItems: boolean;
    };
    error: any;
  },
  transcripts: {
    [learnerId: string]: SimulationTranscriptsState;
  };
}
interface SimulationTranscriptsState {
  fetching: boolean,
  fetched: boolean,
  item: SimulationTranscript[] | null,
  error: any
}

export interface SimulationTranscript {
  role: "bot" | "user";
  time: number;
  endTime: number;
  source: string;
  message: string;
  duration: number;
  secondsFromStart: number;
}

interface SimulationCreationState {
  creating: boolean,
  created: boolean,
  type: string | null,
  item: Simulation | null,
  error: any
}

interface SimulationUpdateState {
  id: string,
  updating: boolean,
  updated: boolean,
  item: Simulation | null,
  error: any
}

interface SimulationDeletionState {
  id: string,
  deleting: boolean,
  deleted: boolean,
  error: any
}

interface SimulationEditState {
  item: Simulation,
  generateSummary: GenerateSummaryState,
  editorSessions: SimulationEditorSessionState[],
  shuffle: ShuffleConfigurationState,
  errors: SimulationValidationError[],
}

interface GenerateSummaryState {
  generating: boolean,
  generated: boolean,
  error: any,
}

interface SimulationPublishState {
  id: string,
  publishing: boolean,
  published: boolean,
  item: Simulation | null,
  error: any
}

interface SimulationState {
  loading: boolean;
  loaded: boolean;
  item: Simulation | null;
  error: any;
  enroll: EnrollSimulationState | null,
}

interface PersonalitiesState {
  loading: boolean;
  loaded: boolean;
  items: Personality[];
  error: any;
}

interface VoicesState {
  loading: boolean;
  loaded: boolean;
  items: Voice[];
  pagination: {
    currentPage: number,
    totalPages: number,
    recordsPerPage: number,
    totalRecordsCount: number,
    hasMoreItems: boolean
  }
  error: any;
}

interface ShuffleConfigurationState {
  persona: {
    loading: boolean;
    loaded: boolean;
    item: Persona | null;
    error?: any;
  },
  organization: {
    loading: boolean;
    loaded: boolean;
    item: OrganizationInfo | null;
    error?: any;
  },
  objectives: {
    loading: boolean;
    loaded: boolean;
    item: Objectives | null;
    error?: any;
  }
}

interface EnrollSimulationState {
  id?: string,
  enrolling: boolean,
  enrolled: boolean,
  error: any
}

const initialState: SimulationsState = {
  creation: null,
  edit: null,
  simulation: {},
  update: {},
  deletion: {},
  publish: null,
  personalities: {
    loading: false,
    loaded: false,
    items: [],
    error: null
  },
  voices: {
    loading: false,
    loaded: false,
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 0,
      totalRecordsCount: 0,
      hasMoreItems: false
    },
    error: null,
  },
  learnerReport: {},
  attemptLearners: {
    loading: false,
    loaded: false,
    items: [],
    pagination: {
      currentPage: -1,
      totalPages: 0,
      recordsPerPage: 20,
      totalRecordsCount: 0,
      hasMoreItems: false,
    },
    error: null,
  },
  transcripts: {}
}

const initialSimulationCreationState: SimulationCreationState = {
  creating: false,
  created: false,
  type: null,
  item: null,
  error: null
}

const initialSimulationUpdateState: SimulationUpdateState = {
  id: '',
  updating: false,
  updated: false,
  item: null,
  error: null
}

const initialSimulationPublishState: SimulationPublishState = {
  id: '',
  publishing: false,
  published: false,
  item: null,
  error: null
}

const initialSimulationDeletionState: SimulationDeletionState = {
  id: '',
  deleting: false,
  deleted: false,
  error: null
}


export function simulationReducer(state: SimulationsState = initialState, action: UnknownAction): SimulationsState {
  switch (action.type) {
    case CREATE_SIMULATION_REQUEST: {
      const { type } = action.payload as CreateSimulationRequest;
      return {
        ...state,
        creation: {
          ...initialSimulationCreationState,
          creating: true,
          type: type,
        }
      }
    }

    case CREATING_SIMULATION_SUCCEEDED: {
      const { response } = action.payload as CreateSimulationResponse;
      const creationState = state.creation;
      if (!creationState) {
        return state;
      }

      return {
        ...state,
        creation: {
          ...creationState,
          creating: false,
          created: true,
          item: response,
          error: null
        }
      }
    }

    case CREATING_SIMULATION_FAILED: {
      const { error } = action.payload as CreateSimulationErrorResponse;
      const creationState = state.creation;
      if (!creationState) {
        return state;
      }

      return {
        ...state,
        creation: {
          ...creationState,
          creating: false,
          created: true,
          error: error
        }
      }
    }

    case INVALIDATE_SIMULATION_CREATION_STATE: {
      return {
        ...state,
        creation: null,
      }
    }

    case FETCH_DRAFT_SIMULATION_REQUEST: {
      const id = action.payload as string;

      const simulationState = state.simulation[id] || {
        loading: false,
        loaded: false,
        item: null,
        error: null
      };

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            loading: true,
            loaded: false,
            error: null
          }
        }
      }
    }

    case FETCHING_DRAFT_SIMULATION_SUCCEEDED: {
      const { response } = action.payload as FetchSimulationResponse;

      if (!response || !response.id) {
        return state;
      }

      const simulationState = state.simulation[response.id];
      if (!simulationState) {
        return simulationState;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [response.id]: {
            ...simulationState,
            loading: false,
            loaded: true,
            item: {
              ...response,
            },
            error: null,
          }
        }
      }
    }

    case FETCHING_DRAFT_SIMULATION_FAILED: {
      const { id, error } = action.payload as FetchSimulationErrorResponse;

      const simulationState = state.simulation[id];
      if (!simulationState) {
        return simulationState;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            loading: false,
            loaded: false,
            item: null,
            error: error,
          }
        }
      }
    }

    case EDIT_SIMULATION_REQUEST: {
      const simulation = action.payload as Simulation;

      return {
        ...state,
        edit: {
          item: simulation,
          editorSessions: [],
          errors: [],
          shuffle: {
            persona: {
              loading: false,
              loaded: false,
              item: null
            },
            organization: {
              loading: false,
              loaded: false,
              item: null
            },
            objectives: {
              loading: false,
              loaded: false,
              item: null
            }
          },
          generateSummary: {
            generating: false,
            generated: false,
            error: null
          }
        }
      }
    }

    case UPDATE_VALIDATION_ERRORS_FOR_SIMULATION: {
      const { simulation, errors } = action.payload as UpdateValidationErrorsForSimulationRequest;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          errors: errors
        }
      }
    }

    case UPDATE_SIMULATION_PROPERTY_REQUEST: {
      const { simulation, property, value } = action.payload as UpdateSimulationPropertyRequest;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      let updatedItem = _.cloneDeep(editState.item);
      updatedItem = _.set(updatedItem, property, value);

      const errors = validateSimulationRequest(updatedItem);

      return {
        ...state,
        edit: {
          ...editState,
          item: updatedItem,
          errors: errors
        }
      }
    }

    case UPDATING_SIMULATION_REQUEST: {
      const { id } = action.payload as UpdateSimulationRequest;
      let updateState = state.update[id] || initialSimulationUpdateState;

      updateState = {
        ...updateState,
        id,
        updating: true,
        updated: false,
        item: null,
        error: null
      }

      return {
        ...state,
        update: {
          ...state.update,
          [id]: updateState
        }
      }
    }

    case DISCARD_SIMULATION_DRAFT_REQUEST: {
      const id = action.payload as string;
      let updateState = state.update[id] || initialSimulationUpdateState;

      updateState = {
        ...updateState,
        id,
        updating: true,
        updated: false,
        item: null,
        error: null
      }

      return {
        ...state,
        update: {
          ...state.update,
          [id]: updateState
        }
      }
    }

    case INVALIDATE_SIMULATION_UPDATE_STATE: {
      return {
        ...state,
        update: {},
      };
    }

    case UPDATING_SIMULATION_SUCCEEDED:
    case DISCARDING_SIMULATION_DRAFT_SUCCEEDED: {
      const { response } = action.payload as UpdateSimulationResponse;
      const id = response.id;
      if (!id) {
        return state;
      }

      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      const simulationState = state.simulation[id];
      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            updating: false,
            updated: true,
            item: response,
            error: null
          }
        },
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            item: response,
          },
        },
        edit: {
          ...state.edit || {
            item: null,
            editorSessions: [],
            errors: [],
            generateSummary: {
              generating: false,
              generated: false,
              error: null
            },
          },
          item: response,
          errors: [],
          shuffle: {
            persona: {
              loading: false,
              loaded: false,
              item: null
            },
            organization: {
              loading: false,
              loaded: false,
              item: null
            },
            objectives: {
              loading: false,
              loaded: false,
              item: null
            }
          },
        }
      }
    }

    case UPDATING_SIMULATION_FAILED:
    case DISCARDING_SIMULATION_DRAFT_FAILED: {
      const { id, error } = action.payload as UpdateSimulationErrorResponse;
      const updateState = state.update[id];
      if (!updateState) {
        return state;
      }

      return {
        ...state,
        update: {
          ...state.update,
          [id]: {
            ...updateState,
            updating: false,
            updated: false,
            error: error
          }
        }
      }
    }

    case PUBLISHING_SIMULATION_REQUEST: {
      const id = action.payload as string;
      return {
        ...state,
        publish: {
          ...initialSimulationPublishState,
          id,
          publishing: true,
        }
      }
    }

    case PUBLISHING_SIMULATION_SUCCEEDED: {
      const { response } = action.payload as PublishSimulationResponse;
      const publishState = state.publish;
      if (!publishState) {
        return state;
      }

      if (publishState.id !== response.id) {
        return state;
      }

      let editState = state.edit;
      if (editState) {
        const { status, hasChanges, lastPublished, publishedBy } = response;
        editState = {
          ...editState,
          item: {
            ...editState.item,
            status,
            hasChanges,
            lastPublished,
            publishedBy
          }
        }
      }

      return {
        ...state,
        publish: {
          ...publishState,
          publishing: false,
          published: true,
          item: response,
          error: null
        },
        edit: editState
      }
    }

    case PUBLISHING_SIMULATION_FAILED: {
      const { id, error } = action.payload as PublishSimulationErrorResponse;
      const publishState = state.publish;
      if (!publishState) {
        return state;
      }

      if (publishState.id !== id) {
        return state;
      }

      return {
        ...state,
        publish: {
          ...publishState,
          publishing: false,
          published: false,
          error: error
        }
      }
    }

    case INVALIDATE_PUBLISH_SIMULATION: {
      return {
        ...state,
        publish: null,
      };
    }

    case CREATING_SIMULATION_EDITOR_CHAT_REQUEST: {
      const { simulation, session, configurationType, input } = action.payload as CreateSimulationEditorChatRequest;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      let sessions = editState.editorSessions || [];
      const existingSession = sessions.find((s) => s.session === session && s.configurationType === configurationType);
      if (existingSession) {
        sessions = sessions.map((s) => {
          if (s.session === session && s.configurationType === configurationType) {
            return {
              ...s,
              chats: [...s.chats, {
                input: input,
                output: "",
                parameters: null,
                creating: true,
                created: false,
                error: null
              }]
            }
          }

          return s;
        });
      } else {
        sessions = [
          ...sessions,
          {
            session,
            configurationType,
            chats: [{
              input: input,
              output: "",
              parameters: null,
              creating: true,
              created: false,
              error: null
            }]
          }
        ]
      }

      return {
        ...state,
        edit: {
          ...editState,
          editorSessions: sessions
        }
      }
    }

    case CREATING_SIMULATION_EDITOR_CHAT_SUCCEEDED: {
      const { simulation, session, configurationType, input, output, parameters } = action.payload as CreateSimulationEditorChatResponse;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      let sessions = editState.editorSessions || [];
      sessions = sessions.map((s) => {
        if (s.configurationType === configurationType) {
          return {
            ...s,
            session: session,
            chats: s.chats.map((c) => {
              if (c.creating && c.input === input) {
                return {
                  ...c,
                  output: output,
                  parameters: parameters,
                  creating: false,
                  created: true,
                  error: null
                }
              }

              return c;
            })
          }
        }

        return s;
      });

      return {
        ...state,
        edit: {
          ...editState,
          editorSessions: sessions
        }
      }
    }

    case CREATING_SIMULATION_EDITOR_CHAT_FAILED: {
      const { simulation, configurationType, error } = action.payload as CreateSimulationEditorChatErrorResponse;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      let sessions = editState.editorSessions || [];
      sessions = sessions.map((s) => {
        if (s.configurationType === configurationType) {
          return {
            ...s,
            chats: s.chats.map((c) => {
              if (c.creating) {
                return {
                  ...c,
                  output: "",
                  creating: false,
                  created: false,
                  error: error
                }
              }

              return c;
            })
          }
        }

        return s;
      });

      return {
        ...state,
        edit: {
          ...editState,
          editorSessions: sessions
        }
      }
    }

    case GENERATING_SUMMARY_FOR_SIMULATION_REQUEST: {
      const { simulation } = action.payload as GenerateSimulationSummaryRequest;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          generateSummary: {
            generating: true,
            generated: false,
            error: null
          }
        }
      }
    }

    case GENERATING_SUMMARY_FOR_SIMULATION_SUCCEEDED: {
      const { simulation, response } = action.payload as GenerateSimulationSummaryResponse;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          generateSummary: {
            generating: false,
            generated: true,
            error: null
          },
          item: {
            ...editState.item,
            description: response
          }
        }
      }
    }

    case GENERATING_SUMMARY_FOR_SIMULATION_FAILED: {
      const { simulation, error } = action.payload as GenerateSimulationSummaryErrorResponse;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          generateSummary: {
            generating: false,
            generated: false,
            error: error
          }
        }
      }
    }

    case INAVLIDATE_GENERATE_SUMMARY_FOR_SIMULATION: {
      const simulation = action.payload as string;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== simulation) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          generateSummary: {
            generating: false,
            generated: false,
            error: null
          }
        }
      }
    }

    case FETCHING_PERSONALITIES_FOR_SIMULATION_REQUEST: {
      return {
        ...state,
        personalities: {
          ...state.personalities,
          loading: true,
          loaded: false,
          error: null
        }
      }
    }

    case FETCHING_PERSONALITIES_FOR_SIMULATION_SUCCEEDED: {
      const { response } = action.payload as FetchPersonalitiesResponse;

      return {
        ...state,
        personalities: {
          ...state.personalities,
          loading: false,
          loaded: true,
          items: response,
          error: null
        }
      }
    }

    case FETCHING_PERSONALITIES_FOR_SIMULATION_FAILED: {
      const { error } = action.payload as FetchPersonalitiesErrorResponse;

      return {
        ...state,
        personalities: {
          ...state.personalities,
          loading: false,
          loaded: false,
          error: error
        }
      }
    }

    case FETCHING_VOICES_FOR_SIMULATION_REQUEST: {
      return {
        ...state,
        voices: {
          ...state.voices,
          loading: true,
          loaded: false,
          error: null
        }
      }
    }

    case FETCHING_VOICES_FOR_SIMULATION_SUCCEEDED: {
      const { response } = action.payload as FetchVoicesResponse;

      const existingItems: Voice[] = state.voices.items;

      let records = response.records;
      if (response.currentPage > 0) {
        records = [...existingItems, ...records];
      }

      records = _.uniqBy(records, 'id');

      return {
        ...state,
        voices: {
          ...state.voices,
          loading: false,
          items: records,
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
            hasMoreItems: response.currentPage < response.totalPages - 1
          }
        }
      }
    }

    case FETCHING_VOICES_FOR_SIMULATION_FAILED: {
      const { error } = action.payload as FetchVoicesErrorResponse;

      return {
        ...state,
        voices: {
          ...state.voices,
          loading: false,
          loaded: false,
          error: error
        }
      }
    }

    case SHUFFLING_PERSONA_FOR_SIMULATION_REQUEST: {
      const id = action.payload as string;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            persona: {
              loading: true,
              loaded: false,
              item: null
            }
          }
        }
      }
    }

    case SHUFFLING_PERSONA_FOR_SIMULATION_SUCCEEDED: {
      const { id, response } = action.payload as ShufflePersonaResponse;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            persona: {
              loading: false,
              loaded: true,
              item: response
            }
          }
        }
      }
    }

    case SHUFFLING_PERSONA_FOR_SIMULATION_FAILED: {
      const { id, error } = action.payload as ShufflePersonaErrorResponse;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            persona: {
              loading: false,
              loaded: false,
              item: null,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_SHUFFLE_PERSONA_STATE: {
      const id = action.payload as string;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            persona: {
              loading: false,
              loaded: false,
              item: null
            }
          }
        }
      }
    }

    case SHUFFLING_ORGANIZATION_FOR_SIMULATION_REQUEST: {
      const id = action.payload as string;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            organization: {
              loading: true,
              loaded: false,
              item: null
            }
          }
        }
      }
    }

    case CLEAR_ORGANIZATION_FOR_SIMULATION: {
      const editState = state.edit;
      if (!editState) {
        return state;
      }
      return {
        ...state,
        edit: {
          ...editState,
          item: {
            ...editState.item,
            organization: {
              ...editState.item.organization,
              summary: null,
              industry: null,
              employees: null,
              revenue: null,
              tools_used: null,
              name: null,
              description: null
            }   
          },
          shuffle: {
            ...editState.shuffle,
            organization: {
              loading: false,
              loaded: false,
              item: null       
            }
          }
        }
      }
    }

    case CLEAR_PERSONA_FOR_SIMULATION: {
      const editState = state.edit;
      if (!editState) {
        return state;
      }
      return {
        ...state,
        edit: {
          ...editState,
          item: {
            ...editState.item,
            persona: {
              ...editState.item.persona,
              name: null,
              icon: null,
              description: null,
              designation: null,
              profile_summary: null,
              objective_tendencies: null,
              example_statements: null,
              small_talk: null,
              success_metrics: null,
              personality: editState.item.persona?.personality ?? null,
              voice: editState.item.persona?.voice ?? null,
            }
          },
          shuffle: {
            ...editState.shuffle,
            persona: {
              loading: false,
              loaded: false,
              item: null       
            }
          }
        }
      }
    }

    case CLEAR_OBJECTIVES_FOR_SIMULATION: {
      const editState = state.edit;
      if (!editState) {
        return state;
      }
    
      return {
        ...state,
        edit: {
          ...editState,
          item: {
            ...editState.item,
            objectives: {
              ...editState.item.objectives,
              description: null,
              goals: null,
              pain_points: null,
              assessment_questions: null,
              acceptable_responses: null,
              deal_killers: null,
              opportunity_triggers: null,
              assessment_validations: null
            }   
          },
          shuffle: {
            ...editState.shuffle,
            objectives: {
              loading: false,
              loaded: false,
              item: null       
            }
          }
        }
      }
    }

    case SHUFFLING_ORGANIZATION_FOR_SIMULATION_SUCCEEDED: {
      const { id, response } = action.payload as ShuffleOrganizationResponse;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            organization: {
              loading: false,
              loaded: true,
              item: response
            }
          }
        }
      }
    }

    case SHUFFLING_ORGANIZATION_FOR_SIMULATION_FAILED: {
      const { id, error } = action.payload as ShuffleOrganizationErrorResponse;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            organization: {
              loading: false,
              loaded: false,
              item: null,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_SHUFFLE_ORGANIZATION_STATE: {
      const id = action.payload as string;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            organization: {
              loading: false,
              loaded: false,
              item: null
            }
          }
        }
      }
    }

    case SHUFFLING_OBJECTIVES_FOR_SIMULATION_REQUEST: {
      const id = action.payload as string;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            objectives: {
              loading: true,
              loaded: false,
              item: null
            }
          }
        }
      }
    }

    case SHUFFLING_OBJECTIVES_FOR_SIMULATION_SUCCEEDED: {
      const { id, response } = action.payload as ShuffleObjectivesResponse;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            objectives: {
              loading: false,
              loaded: true,
              item: response
            }
          }
        }
      }
    }

    case SHUFFLING_OBJECTIVES_FOR_SIMULATION_FAILED: {
      const { id, error } = action.payload as ShuffleObjectivesErrorResponse;

      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            objectives: {
              loading: false,
              loaded: false,
              item: null,
              error: error
            }
          }
        }
      }
    }

    case INVALIDATE_SHUFFLE_OBJECTIVES_STATE: {
      const id = action.payload as string;
      const editState = state.edit;
      if (!editState) {
        return state;
      }

      if (editState.item.id !== id) {
        return state;
      }

      return {
        ...state,
        edit: {
          ...editState,
          shuffle: {
            ...editState.shuffle,
            objectives: {
              loading: false,
              loaded: false,
              item: null
            }
          }
        }
      }
    }

    case DELETE_SIMULATION_REQUEST: {
      const id = action.payload as string;
      let deletionState = state.deletion[id] || initialSimulationDeletionState;

      deletionState = {
        ...deletionState,
        id,
        deleting: true,
        deleted: false,
        error: null
      }

      return {
        ...state,
        deletion: {
          ...state.deletion,
          [id]: deletionState
        }
      }
    }

    case DELETING_SIMULATION_SUCCEEDED: {
      const { id } = action.payload as DeleteSimulationResponse
      const deletionState = state.deletion[id];
      if (!deletionState) {
        return state;
      }

      return {
        ...state,
        deletion: {
          ...state.deletion,
          [id]: {
            ...deletionState,
            deleting: false,
            deleted: true,
            error: null
          }
        }
      }
    }

    case DELETING_SIMULATION_FAILED: {
      const { id, error } = action.payload as DeleteSimulationErrorResponse;
      const deletionState = state.deletion[id];
      if (!deletionState) {
        return state;
      }

      return {
        ...state,
        deletion: {
          ...state.deletion,
          [id]: {
            ...deletionState,
            deleting: false,
            deleted: false,
            error: error
          }
        }
      }
    }

    case INVALIDATE_SIMULATION_DELETION_STATE: {
      const id = action.payload as string;
      const deletionState = _.omit(state.deletion, id);

      return {
        ...state,
        deletion: deletionState
      }
    }

    case FETCH_PUBLIC_SIMULATION_REQUEST: {
      const {id} = action.payload as FetchPublicSimulationRequest;
      const simulationState = state.simulation[id] || {
        loading: false,
        loaded: false,
        item: null,
        error: null
      };
      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            loading: true,
            loaded: false,
            error: null
          }
        }
      }
    }

    case FETCHING_PUBLIC_SIMULATION_SUCCEEDED: {
      const { simulation, learningRecord } = action.payload as FetchPublicSimulationResponse;

      if (!simulation || !simulation.id) {
        return state;
      }

      const id = simulation.id;

      const simulationState = state.simulation[simulation.id];
      if (!simulationState) {
        return simulationState;
      }

      if (learningRecord) {
        return {
          ...state,
          simulation: {
            ...state.simulation,
            [id]: {
              ...simulationState,
              loading: false,
              loaded: true,
              item: simulation,
              enroll: {
                ...simulationState.enroll,
                enrolling: false,
                enrolled: true,
                id: learningRecord.id,
                error: null
              },
              error: null
            }
          }
        }
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [simulation.id]: {
            ...simulationState,
            loading: false,
            loaded: true,
            item: simulation,
            error: null,
          }
        }
      }
    }

    case FETCHING_PUBLIC_SIMULATION_FAILED: {
      const { id, error } = action.payload as FetchPublicSimulationErrorResponse;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return simulationState;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            loading: false,
            loaded: false,
            item: null,
            error: error,
          }
        }
      }
    }

    case ENROLL_SIMULATION_REQUEST: {
      const {course} = action.payload as EnrollCourseRequest;
      const id = course;
      const simulationState = state.simulation[id];
      console.log("simulation state ", simulationState)
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            enroll: {
              enrolling: true,
              enrolled: false,
              error: null
            }
          }
        }
      }
    }

    case ENROLLING_SIMULATION_SUCCEEDED: {
      const { id, response } = action.payload as EnrollCourseResponse;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      const enrollId = response.learningRecord.id;

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            enroll: {
              id: enrollId,
              enrolling: false,
              enrolled: true,
              error: null
            }
          }
        }
      }
    }

    case ENROLLING_SIMULATION_FAILED: {
      const { id, error } = action.payload as EnrollCourseErrorResponse;
      const simulationState = state.simulation[id];
      if (!simulationState) {
        return state;
      }

      return {
        ...state,
        simulation: {
          ...state.simulation,
          [id]: {
            ...simulationState,
            enroll: {
              enrolling: false,
              enrolled: false,
              error: error
            },
          }
        }
      }
    }


    case FETCH_LEARNER_REPORT: {
      const {id} = action.payload as FetchLearnerReportRequest;

      return {
        ...state,
        learnerReport: {
            loading: true,
            loaded: false,
            error: null
        }
      }
    }

    case FETCHING_LEARNER_REPORT_SUCCEEDED: {
      const { response } = action.payload as FetchLearnerReportResponse;

      return {
        ...state,
        learnerReport: {
          ...state.learnerReport,
            loading: false,
            loaded: true,
            item: response,
            error: null,
          
        }
      }
    }

    case FETCHING_LEARNER_REPORT_FAILED: {
      const { error } = action.payload as FetchLearnerReportErrorResponse;

      return {
        ...state,
        learnerReport: {
          ...state.learnerReport,
            error: error,
        }
      }
    }

    case FETCH_ATTEMPTS_FOR_SIMULATION_REQUEST: {
      const { id } = action.payload as FetchAttemptsForSimulationRequest;
    
      return {
        ...state,
        attemptLearners: {
          ...state.attemptLearners,
            loading: true,
            loaded: false,
            error: null,
          },
        };
      }
    

    case FETCHING_ATTEMPTS_FOR_SIMULATION_SUCCEEDED: {
      const { response } = action.payload as FetchAttemptsForSimulationResponse;

      return {
        ...state,
        attemptLearners: {
          ...state.attemptLearners,
          loading: false,
          loaded: true,
          items: response,
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
            hasMoreItems: response.currentPage < response.totalPages - 1,
          },
        },
      };
    }

    case FETCHING_ATTEMPTS_FOR_SIMULATION_FAILED: {
      const response = action.payload as FetchAttemptsForSimulationErrorResponse;
      return {
        ...state,
        attemptLearners: {
          ...state.attemptLearners,
          loading: false,
          loaded: false,
          error: response.error,
        },
      };
    }


    case FETCH_TRANSCRIPTS_FOR_SIMULATION_REQUEST: {
      const id = action.payload as string;

      const transcriptState = state.transcripts?.[id] || {
        fetching: false,
        fetched: false, 
        item: null,
        error: null
      };
      
      return {
        ...state,
        transcripts: {
          ...state.transcripts,
          [id]: {
            ...transcriptState,
            fetching: true,
            fetched: false, 
            item: null,
            error: null
          }
        }
      }
    }

    case FETCHING_TRANSCRIPTS_FOR_SIMULATION_SUCCEEDED: {
      const { id, response } = action.payload as GetSimulationTranscriptsResponse;
      const transcriptState = state.transcripts?.[id] || {};

      return {
        ...state,
        transcripts: {
          ...state.transcripts,
          [id]: {
            ...transcriptState,
              fetching: false,
              fetched: true,
              item: response,
              error: null
          }
        }
      }
    }

    case FETCHING_TRANSCRIPTS_FOR_SIMULATION_FAILED: {
      const { id, error } = action.payload as GetSimulationTranscriptsErrorResponse;

      const transcriptState = state.transcripts?.[id] || {
        fetching: false,
        fetched: false, 
        item: null,
        error: null
      };

      return {
        ...state,
        transcripts: {
          ...state.transcripts,
          [id]: {
              ...transcriptState,
              fetching: false,
              error: error
          }
        }
      }
    }

    default: {
      return state
    }
  }
}